export default {
  UPLOAD_SUCCESS: { TITLE: 'Fichier téléchargé', DESCRIPTION: 'Votre fichier a été téléchargé avec succès' },
  UPLOAD_FAILED: { TITLE: 'Téléchargement échoué', DESCRIPTION: "Votre fichier n'a pas pu être téléchargé" }
}
